import { render, staticRenderFns } from "./MyCp2.vue?vue&type=template&id=6723b64b&scoped=true&"
import script from "./MyCp2.vue?vue&type=script&lang=js&"
export * from "./MyCp2.vue?vue&type=script&lang=js&"
import style0 from "./MyCp2.vue?vue&type=style&index=0&id=6723b64b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6723b64b",
  null
  
)

export default component.exports